module.exports = __webpack_public_path__ + "img/biker.4956a3f7.svg";